import React from "react";
import Button from "react-bootstrap/Button";
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";

import ButtonSpinner from "../../../components/ButtonSpinner";

interface Props {
    show: boolean;
    title: string;
    saving?: boolean;
    canSave?: boolean;
    onSave: () => void;
    onClose: () => void;
    children: React.ReactNode;
}

/**
 * The right-hand create/edit panel the app uses for its entities (see Content/QuickAnswer/
 * modalForm): light header, scrolling body, sticky footer with full-width Close and Save.
 */
const FormPanel = ({ show, title, saving = false, canSave = true, onSave, onClose, children }: Props) => {
    const { t } = useTranslation(['common']);

    return (
        <Offcanvas direction="end" isOpen={show} toggle={onClose}>
            <form
                noValidate
                className="d-flex flex-column h-100"
                onSubmit={(e) => { e.preventDefault(); if (canSave && !saving) onSave(); }}
            >
                <OffcanvasHeader className="bg-light" toggle={onClose}>{title}</OffcanvasHeader>
                <OffcanvasBody className="p-0 overflow-hidden">
                    <SimpleBar style={{ height: 'calc(100vh - 140px)' }}>
                        <div className="p-4">{show && children}</div>
                    </SimpleBar>
                </OffcanvasBody>
                <div className="offcanvas-footer border-top p-3 text-center position-sticky bottom-0">
                    <div className="d-flex flex-row flex-nowrap gap-2">
                        <Button variant="light" onClick={onClose} className="w-100">{t('common:close')}</Button>
                        <Button variant="primary" type="submit" disabled={saving || !canSave} className="w-100">
                            {t('common:save')}{saving && <ButtonSpinner />}
                        </Button>
                    </div>
                </div>
            </form>
        </Offcanvas>
    );
};

export default FormPanel;
